import { useEffect } from "react";

// Invoke `onEscape` when the Escape key is pressed. Bound at the document level in
// the capture phase so it runs before nested handlers. Re-binds when `onEscape` changes.
export const useEscapeKey = (onEscape: () => void) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      onEscape();
    };
    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [onEscape]);
};
